import { Link } from "react-router";
import { useProposals } from "../../api/queries";
import { Icon } from "../Icon";

export function ProposalsButton({ pid }: { pid: string }) {
  const { data } = useProposals(pid, "pending");
  const n = data?.length ?? 0;
  return (
    <div className="column-footer">
      <Link to={`/p/${pid}/proposals`} className="btn btn-ghost btn-block btn-left">
        <Icon name="lightbulb" size={14} /> <span>Proposals</span>
        {n > 0 && (
          <span className="badge badge-muted" title={`${n} pending proposal${n === 1 ? "" : "s"}`}>
            {n}
          </span>
        )}
      </Link>
    </div>
  );
}
